<template>
  <div class="smartcard">
    <div class="card-header bg-default">
      {{ promoCode.code }}
      <span class="badge badge-primary">{{ promoCode.AccountType.name }}</span>
    </div>
    <div class="list-group list-group-flush">
      <div class="list-group-item">
        <strong>Description</strong><br/>{{ promoCode.description }}
      </div>
      <div class="list-group-item">
        <template v-if="promoCode.type === 'credits'">
          <span class="badge badge-success"><span class="fa fa-dollar-sign"></span></span> Credits
        </template>
        <template v-if="promoCode.type === 'reducedFee'">
          <span class="badge badge-success"><span class="fa fa-percent"></span></span> Reduced Fee
        </template>
        <template v-if="promoCode.type === 'waivedFee'">
          <span class="badge badge-success"><span class="fa fa-ban"></span></span> Waived Fee
        </template>
        <template v-if="promoCode.type === 'waivedFeeCredits'">
          <span class="badge badge-success"><span class="fa fa-dollar-sign"></span></span> Waived Fee + Credits
        </template>
        <span v-if="promoCode.percentDiscount > 0">
          <strong>Rate Discount:</strong><br/>
          <span class="fa fa-percent"></span> {{ promoCode.percentDiscount }}%
        </span>
        <span v-if="promoCode.type !== 'waivedFee'">
          <span class="badge badge-success">{{ promoCode.amount | to_dollar_amount }}</span>
          <span v-if="promoCode.creditDuration > 0" class="badge badge-default">Credits expire in {{ promoCode.creditDuration }} months</span>
          <span v-else class="badge badge-default">Credits do not expire</span>
        </span>
      </div>
      <div class="list-group-item">
        <strong>Expiration Type:</strong>
        <template v-if="promoCode.expirationType === 'scheduled'">
          <span class="fa fa-calendar-alt"></span> Scheduled ({{ promoCode.startDate | short_date_format }} - {{ promoCode.endDate | short_date_format }})
        </template>
        <template v-if="promoCode.expirationType === 'permanent'">
          <span class="fa fa-asterisk"></span> Permanent
        </template>
        <template v-if="promoCode.expirationType === 'limitedUse'">
          <span class="fa fa-ban"></span> Limited Use ({{ promoCode.usageLimit }} uses)
        </template>
      </div>
    </div>
    <div class="card-footer text-right">
      <router-link class="btn btn-sm btn-primary"
      :to="{ path: `/membership/promotions/edit/${promoCode.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromoCode',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    promoCode () {
      return {
        uuid: '',
        code: '',
        description: '',
        startDate: new Date(),
        endDate: new Date(),
        type: '',
        expirationType: '',
        usageLimit: 0,
        amount: 0,
        OrganizationUuid: '',
        AccountType: {
          uuid: '',
          name: ''
        },
        ...this.object
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/PromoCode.vue